import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import {
  formatCurrencyView,
  handleCurrencyChange,
  unformatCurrency,
} from '../../utils/currencyUtils';
import DefaultModal from '../modals/DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';
import useProgramaSituacao from '../hooks/useProgramaSituacao';

const PagarDespesaModal = ({ show, onClose, despesa, onSaveSuccess }) => {
  const [formData, setFormData] = useState({
    ano: '',
    idDespesa: '',
    idPrograma: '',
    idAcao: '',
    idSubAcao: '',
    idItem: '',
    cnpjAssociacao: '',
    idElementoDespesa: '',
    idFonteRecurso: '',
    idFavorecido: '',
    nomeFavorecido: '', // Corrigido: variável estava sem valor inicial
    objetoResumido: '',
    objetoDetalhado: '',
    notaFiscal: '',
    dataNf: '',
    dataElaboracao: '',
    dataPagamento: '',
    formaPagamento: '',
    valor: '',
  });

  const [isLoading, setIsLoading] = useState(true);
  const [isProgramaInativo, setIsProgramaInativo] = useState(false);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { isProgramaAtivo } = useProgramaSituacao();

  useEffect(() => {
    if (show) {
      const fetchInitialData = async () => {
        setIsLoading(true);
        try {
          if (despesa) {
            const dataAtual = new Date().toISOString().split('T')[0];

            setFormData({
              ano: despesa.ano || '',
              idDespesa: despesa.idDespesa || '',
              idPrograma: despesa.idPrograma || despesa.programa?.id || '',
              idAcao: despesa.idAcao || despesa.acao?.id || '',
              idSubAcao: despesa.idSubAcao || '',
              idItem: despesa.idItem || '',
              cnpjAssociacao: despesa.cnpjAssociacao || cnpj || '',
              idElementoDespesa:
                despesa.idElementoDespesa || despesa.elementoDespesa?.id || '',
              idFonteRecurso:
                despesa.idFonteRecurso || despesa.fonteRecurso?.id || '',
              idFavorecido: despesa.idFavorecido || '',
              nomeFavorecido: despesa.nomeFavorecido || '',
              objetoResumido: despesa.objetoResumido || '',
              objetoDetalhado: despesa.objetoDetalhado || '',
              notaFiscal: despesa.notaFiscal || '',
              dataNf: despesa.dataNf || '',
              dataElaboracao: despesa.dataElaboracao || '',
              dataPagamento: despesa.dataPagamento || dataAtual,
              formaPagamento: despesa.formaPagamento || '',
              valor: formatCurrencyView(despesa.valor ?? 0),
            });
          }
        } catch (error) {
          console.error('Erro ao carregar dados:', error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchInitialData();
    }
  }, [show, despesa, cnpj]);

  // Verificar se o programa está encerrado
  useEffect(() => {
    if (formData.idPrograma) {
      const programaAtivo = isProgramaAtivo(formData.idPrograma);
      setIsProgramaInativo(!programaAtivo);
    } else {
      setIsProgramaInativo(false);
    }
  }, [formData.idPrograma, isProgramaAtivo]);

  const handleValorChange = e => {
    handleCurrencyChange(e, setFormData);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    let processedValue = value;

    if (
      ['idPrograma', 'idAcao', 'idElementoDespesa', 'idFonteRecurso'].includes(
        name
      )
    ) {
      processedValue = value ? parseInt(value) : '';
    }

    if (typeof processedValue === 'string') {
      processedValue = processedValue.toUpperCase();
    }

    setFormData(prev => ({
      ...prev,
      [name]: processedValue,
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();

    // Verificar se o programa está encerrado
    if (formData.idPrograma && !isProgramaAtivo(formData.idPrograma)) {
      showDefaultModal(
        'error',
        'Este programa está ENCERRADO. Não é possível editar pagamentos de programas encerrados.'
      );
      return;
    }

    if (!formData.dataPagamento) {
      showDefaultModal('error', 'Por favor, informe a data do pagamento.');
      return;
    }

    if (!formData.formaPagamento) {
      showDefaultModal('error', 'Por favor, selecione o meio de pagamento.');
      return;
    }

    const payload = {
      ...formData,
      ano: formData.ano || new Date().getFullYear(),
      cnpjAssociacao: cnpj,
      idPrograma: formData.idPrograma || null,
      idAcao: formData.idAcao || null,
      idSubAcao: formData.idSubAcao || null,
      idItem: formData.idItem || null,
      valor: unformatCurrency(formData.valor),
    };
console.log('Payload enviadoAgora:', payload);
    const url = `${API_BASE_URL.DESPESA}/update_pagamento`;

    axios
      .put(url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => {
        let savedData = null;

        if (response.data) {
          if (
            typeof response.data === 'object' &&
            response.data !== null &&
            response.data.id
          ) {
            savedData = response.data;
          } else if (
            typeof response.data === 'number' ||
            (typeof response.data === 'string' && !isNaN(response.data))
          ) {
            savedData = { ...payload, id: parseInt(response.data) };
          } else {
            savedData = { ...payload, isNewRecord: true };
          }
        } else {
          savedData = { ...payload, isNewRecord: true };
        }

        showDefaultModal('success', 'Pagamento registrado com sucesso!', () => {
          try {
            onSaveSuccess(savedData);
          } catch (error) {
            onSaveSuccess();
          }
          onClose();
        });
      })
      .catch(error => {
        console.error('Erro ao salvar formData:', error);
        const errorMessage =
          error.response?.data?.message || 'Erro ao salvar. Tente novamente.';
        showDefaultModal('error', errorMessage);
      });
  };

  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div
              className="modal-header bg-success text-white"
              style={{ height: '30px' }}
            >
              <h5 className="modal-title">PAGAMENTO</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {isLoading ? (
                <div className="text-center py-4">Carregando dados...</div>
              ) : (
                <>
                  {isProgramaInativo && (
                    <div className="alert alert-warning mb-3" role="alert">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      Este programa está <strong>ENCERRADO</strong>. Você pode visualizar os dados, mas não é possível salvar alterações.
                    </div>
                  )}
                  <form onSubmit={handleSubmit}>

                  <div className="mb-3 p-3 bg-light rounded">
                    <h6 className="mb-2 text-muted">Dados da Despesa:</h6>
                    <div className="row g-1 small">
                      <div className="col-6">
                        <strong>Nº:</strong> {formData.idDespesa}
                      </div>
                      <div className="col-6">
                        <strong>Ano:</strong> {formData.ano}
                      </div>
                      <div className="col-12">
                        <strong>Favorecido:</strong>{' '}
                        {formData.nomeFavorecido || 'N/A'}
                      </div>
                      <div className="col-12">
                        <strong>Nota Fiscal:</strong>{' '}
                        {formData.notaFiscal || 'N/A'}
                      </div>
                    </div>
                  </div>

                  <div className="row g-1 small">
                    <div className="col-3 input-group-sm">
                      <label className="form-label">
                        <strong>Valor a Pagar</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control text-end fw-bold"
                        value={formData.valor || 'R$ 0,00'}
                        onChange={handleValorChange}
                        onFocus={e => e.target.select()}
                        disabled
                        style={{
                          backgroundColor: '#e9ecef',
                          fontSize: '1.1em',
                        }}
                      />
                    </div>

                    <div className="col-3 input-group-sm">
                      <label className="form-label">Data do Pagamento *</label>
                      <input
                        type="date"
                        className="form-control"
                        name="dataPagamento"
                        value={formData.dataPagamento}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-6 input-group-sm">
                      <label className="form-label">Meio de Pagamento *</label>
                      <select
                        className="form-select"
                        name="formaPagamento"
                        value={formData.formaPagamento}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Selecione...</option>
                        <option value="CHEQUE">CHEQUE</option>
                        <option value="DÉBITO EM CONTA">DÉBITO EM CONTA</option>
                        <option value="DEPÓSITO BANCÁRIO">
                          DEPÓSITO BANCÁRIO
                        </option>
                        <option value="DINHEIRO">DINHEIRO</option>
                        <option value="PIX">PIX</option>
                        <option value="TRANSFERÊNCIA BANCÁRIA">
                          TRANSFERÊNCIA BANCÁRIA
                        </option>
                        <option value="OUTROS">OUTROS</option>
                      </select>
                    </div>
                  </div>

                  <div className="modal-footer mt-3">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={onClose}
                    >
                      Cancelar
                    </button>
                    <button 
                      type="submit" 
                      className="btn btn-success btn-sm"
                      disabled={isProgramaInativo}
                      title={isProgramaInativo ? 'Programa ENCERRADO - não é possível editar pagamento' : 'Confirmar pagamento'}
                    >
                      <i className="bi bi-cash-coin me-1"></i>
                      Confirmar Pagamento
                    </button>
                  </div>
                </form>
                  </>
              )}
            </div>
          </div>
        </div>
      </div>

      <DefaultModal {...setDefaultModal} />
    </>
  );
};

export default PagarDespesaModal;
